import {
  ChevronLeftIcon,
  ChevronRightIcon,
  XCircleIcon,
} from '@heroicons/react/solid';
import React, { useState } from 'react';
import Swipe from 'react-easy-swipe';

const ImageSwiper = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const nextSlide = () => {
    let newSlide =
      currentSlide === props.images.length - 1 ? 0 : currentSlide + 1;
    setCurrentSlide(newSlide);
  };

  const prevSlide = () => {
    let newSlide =
      currentSlide === 0 ? props.images.length - 1 : currentSlide - 1;
    setCurrentSlide(newSlide);
  };

  const removeImage = () => {
    props.removeImage(props.images[currentSlide]);
    setCurrentSlide(0);
  };

  if (!props.images || props.images.length === 0) {
    return (
      <img
        className="h-96 rounded w-full object-cover object-center"
        src="https://dummyimage.com/400x600"
        alt="content"
      />
    );
  }

  return (
    <div className="overflow-x-auto gap-6 snap-x snap-mandatory before:shrink-0 before:w-3 after:shrink-0 after:w-3 relative">
      {props.images.length > 1 && (
        <ChevronLeftIcon
          onClick={prevSlide}
          className="h-6 w-6 text-white bg-gray-800 border-2 border-white rounded-full absolute left-0 inset-y-1/2 cursor-pointer hover:text-gray-300"
        />
      )}

      <Swipe onSwipeLeft={nextSlide} onSwipeRight={prevSlide}>
        {props.images.map((slide, index) => {
          return (
            <div key={index}>
              <img
                src={slide.url}
                alt={slide.name}
                onClick={!props.isModal ? props.showImages : undefined}
                className={
                  index === currentSlide
                    ? props.isModal
                      ? 'rounded w-full object-contain object-center'
                      : 'h-96 rounded w-full object-cover object-center cursor-pointer'
                    : 'hidden'
                }
                // onMouseEnter={() => {
                //   this.setState({ paused: true });
                // }}
                // onMouseLeave={() => {
                //   this.setState({ paused: false });
                // }}
              />
              {props.isLoggedin && (
                <button
                  onClick={removeImage}
                  type="button"
                  className="absolute top-0 right-0 text-red-400 rounded hover:text-red-500"
                >
                  <XCircleIcon className="w-5 h-5" />
                </button>
              )}
            </div>
          );
        })}
      </Swipe>

      {props.images.length > 1 && (
        <ChevronRightIcon
          onClick={nextSlide}
          className="h-6 w-6 text-white bg-gray-800 border-2 border-white rounded-full absolute right-0 text-3xl inset-y-1/2 cursor-pointer hover:text-gray-300"
        />
      )}
    </div>
  );
};

export default ImageSwiper;
